export default __webpack_public_path__ + "static/media/bellow_header_img.4a5bfcec.png";